function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.13236 4.66185C5.13799 4.6563 5.14024 4.6489 5.14586 4.64335L9.07297 1.07553C9.29233 0.874795 9.29233 0.549185 9.07297 0.348454C9.07072 0.346604 9.06847 0.34568 9.06622 0.344755C9.01741 0.296149 8.95629 0.256894 8.88712 0.229732C8.81795 0.202571 8.7424 0.188157 8.66575 0.1875L0.810411 0.1875C0.732355 0.188537 0.655528 0.203655 0.585357 0.231787C0.515186 0.259918 0.453383 0.300377 0.404314 0.350305L0.402064 0.348454C0.295905 0.449454 0.237488 0.578493 0.237488 0.71199C0.237488 0.845486 0.295905 0.974526 0.402064 1.07553L4.33817 4.66185C4.38717 4.70909 4.44805 4.74701 4.51661 4.77302C4.58516 4.79903 4.65976 4.8125 4.73527 4.8125C4.81077 4.8125 4.88537 4.79903 4.95393 4.77302C5.02248 4.74701 5.08336 4.70909 5.13236 4.66185V4.66185Z",
  fill: "#462F8D"
});

var SvgArrowOpen = function SvgArrowOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowOpen.6ceef0af.svg";
export { ForwardRef as ReactComponent };